export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-regular-b0408b306b1c0be2bfef0dadf6c6e3ac.ttf";